import { post } from "@/utils/request";

export const login = (params) => post("/api/base/login", params);
export const getAuth = (params) => post("/api/base/getCurrentUser", params);
export const getMsgCodeForManagerUser = (params) => post("/mall-message/verifyCode/getMsgCodeForRearServiceUser", params);
